import React, { Fragment, useEffect, useState } from "react";
import { subDays } from 'date-fns';
import Common from "../../../Common/Common";
import FormHeader from "../../../Common/FormHeader";
import ToperReports from "./ToperReports";
import requestApi from "../../../services/requestApi.service";
import {faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons/faMagnifyingGlass";
export default function CallLogReport1(){

    let defaultDate = {};
    defaultDate['Start_DateTime'] = [subDays(new Date(), 6), new Date()];
    defaultDate['Start_DateTime'][0].setHours(0, 0, 0, 0);
    defaultDate['Start_DateTime'][1].setHours(23, 59, 59, 999);
    defaultDate['noofdays'] = 7;
    let filterText = {};
    filterText['Select CallType'] = [{label : 'All', value : 'All'}];
    filterText['Select Employees'] = [{label : 'All', value : 'All'}];

    const [formname, setSetFormname] = useState(process.env.REACT_APP_CALLLOG_FORMNAME);
    const [showLoader, setShowLoader] = useState(false);
    const [filterTxt, setfilterTxt] = useState(filterText);
    const [dateFilter, setDateFilter] = useState(defaultDate);
    const [usersList, setUsersList] = useState('');
    const [submit, setSubmit] = useState(false);
    const [toppersData, setToppersData] = useState([]);

    useEffect(() => {
        getCallLogData();
    }, [])

    useEffect(() => {

    }, [submit])

    const getCallLogData = async () => {
        let params = {
            "ENTITY": "MOBILE_PROCESS",
            "OPERATION": "GET_USERS_FOR_CALL_LOG",
            "FORMNAME": formname,
            "isOtherApiReq" : true,
        };
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            let data = response.data;
            setUsersList(data);
            await loadAnalyticsData();
            
        }
    }

    const loadAnalyticsData = async () =>{
        setShowLoader(true);
        await getToperReports();
        setShowLoader(false);
    }

    const getRequestJsonObj = () => {
        let filterOption = [dateFilter,filterTxt];
        let neededFilters = [
            {'dateFilter' : true},
            {'users' : true},
            {'type' : false},
        ];
        let params = {
            "ENTITY": "MOBILE_PROCESS",
            "OPERATION": "GET_TOPER_REPORTS",
            "FORMNAME": formname,
            "isOtherApiReq" : true,
            "FILTEROPTION" : filterOption,
            "NEEDEDFILTERS" : neededFilters,
        };
        return params;
    }

    const getToperReports = async () => {
        setToppersData([]);
        let params = getRequestJsonObj();
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            let data = response.data;
            setToppersData(data);
        }
    }
    
    const handleDateChange = (name,selectedDates, noofdays) => {
        if(name === 'Start_DateTime'){
            dateFilter[name] = selectedDates;
            dateFilter['noofdays'] = noofdays;
            setDateFilter(dateFilter);
        }
    }

    const handleSelectChange = async (name,selectedOptions) => {
        filterTxt[name] = selectedOptions;
        setfilterTxt(filterTxt);
    }

    const handleBtnClick = async () => {
        let selecteduser = [...filterTxt['Select Employees'], ...usersList.filter(UserList => !filterTxt['Select Employees'].some(selectedOption => selectedOption.value === UserList.value))];
        setUsersList(selecteduser);
        await loadAnalyticsData();
    }

    let selectOptions = [
        {
            'name' : 'Select Employees',
            'label' : 'Select Employees',
            'options' : usersList,
            'multiple' : true,
            'id' : 0,
        }
    ];

    let dateOptions = [
        {
            name : `Start_DateTime`,
            placeholder : `Select Date Range`,
            defaultValue : dateFilter['Start_DateTime']
        }
    ];

    let buttons = [
        {
            name : 'search',
            lable : 'Search',
            icon : faMagnifyingGlass
        }
    ]

    return(
        <div>
            <Common
                pageTitle={"Calls Topper"} 
                showLoader={showLoader} 
                mainContent={
                    <Fragment>
                        <FormHeader
                            selectOptions={selectOptions}
                            dateOptions={dateOptions}
                            handleDateChange={handleDateChange}
                            handleSelectChange={handleSelectChange}
                            handleBtnClick={handleBtnClick}
                            buttonOptions={buttons}
                            prefix={"calls_analytics"}
                        />
                        <div className="listview-container pb10 kv-main-wrapper h100per w-100 ">
                            {toppersData.length > 0 && <ToperReports
                                formname={formname}
                                dateFilter={dateFilter}
                                filterTxt={filterTxt}
                                type={"calls_analytics"}
                                data={toppersData}
                            />}
                        </div> 
                    </Fragment>
                }
            />
        </div>
    )
}
